import { ReferenceItem, ReferenceValue } from '../../../../../../types/types';

interface GetAdditionalSelectedItemsOptions {
  value: ReferenceValue;
  newData: any[];
  idItem: string;
  labelItem: string;
  selectedItems: ReferenceItem[];
  delimiter?: string;
  formatLabel?: (value: string) => string;
}

// Finds IDs from the delimited value that arrived in the latest lazy page
// but are not yet in selectedItems — keeps popover checked-state in sync without
// triggering onChange.
export const getAdditionalSelectedItems = ({
  value,
  newData,
  idItem,
  labelItem,
  selectedItems,
  delimiter = ',',
  formatLabel = (label) => label,
}: GetAdditionalSelectedItemsOptions): ReferenceItem[] => {
  const splittedValue = String(value).split(delimiter);
  const additionalItems: ReferenceItem[] = [];
  newData.forEach((item) => {
    const itemId = String(item[idItem]);
    if (
      splittedValue.includes(itemId) &&
      !selectedItems.some(({ value: sv }) => String(sv) === itemId)
    ) {
      additionalItems.push({
        value: itemId,
        label: formatLabel(String(item[labelItem])),
      });
    }
  });
  return additionalItems;
};
